export default __webpack_public_path__ + "static/dreifaltigkeit-3-ad9e576b0c8fae652943c624c4c09c71.png";